import classNames from 'classnames'
import { ElDrawer } from 'element-plus'
import type { FunctionalComponent, StyleValue } from 'vue'
import './HocElDrawer.scss'

type ElDrawerProps = InstanceType<typeof ElDrawer>['$props'] & {
  style?: StyleValue
  class?: string
}

export const HocElDrawer: FunctionalComponent<ElDrawerProps> = (_props, { slots, attrs }) => {
  return (
    <ElDrawer {...attrs} class={classNames('hoc-el-drawer', attrs.class as string)}>
      {{
        header: () => slots.header?.(),
        default: () => slots.default?.(),
        footer: () => slots.footer?.(),
      }}
    </ElDrawer>
  )
}
HocElDrawer.inheritAttrs = false
